import {
    GET_BOOKING_DATA_START,
    GET_BOOKING_DATA_SUCCESS,
    GET_BOOKING_DATA_ERROR
} from '../../constants';
import { getBookingById as query } from '../../lib/graphql';

export function getBooking(id) {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: GET_BOOKING_DATA_START,
            });

            const { data } = await client.query({
                query,
                variables: {
                    bookingId: Number(id)
                },
                fetchPolicy: "network-only",
            });

            if (!data?.getBookingById) {
                dispatch({
                    type: GET_BOOKING_DATA_ERROR,
                });
            } else {
                dispatch({
                    type: GET_BOOKING_DATA_SUCCESS,
                    bookingDetails: data?.getBookingById?.result
                });
            }
        } catch (error) {
            dispatch({
                type: GET_BOOKING_DATA_ERROR,
                payload: {
                    error
                }
            });
            return false;
        }
        return true;
    };
}
